import {AbTestingUtils} from "../../../infrastructure/utils/ab-testing-utils";
import {LocalStorageUtils} from "../../../infrastructure/utils/local-storage.utils";
import {LOCAL_STORAGE_KEYS} from "../../../core/consts";
import {WEBSITE_MODULE_REMOTE_CONFIG} from "../website-module.remote-config";
import {RemoteConfigManager} from "../../../third-party-services/remote-config/remote-config-manager";
import {WebsiteModuleState} from "../models/website-module.state";
import {RouterController} from "../../../core/components/router/router-controller";
import {WebToAppCtaLocalStorageModel} from "../../../core/models/web-to-app-cta/web-to-app-cta.local-storage.model";
import {singleton} from "../../../infrastructure/decorators/singleton";
import {WEBSITE_MODULE} from "../website-module.consts";
import {ActionHandler} from "../../../infrastructure/handlers/action-handler";
import type {WebToAppCTAModel} from "../../../core/models/web-to-app-cta/web-to-app-cta.model";

@singleton
export class WebsiteModuleWebToCtaAppHandler extends ActionHandler {
  type = WEBSITE_MODULE.ACTION_TYPES.webTopAppCTAVisibleHandler
  localStorageUtils: LocalStorageUtils;
  abTestingUtils: AbTestingUtils;
  remoteConfigManager: RemoteConfigManager;
  routerController: RouterController;
  state: WebsiteModuleState;
  pageNum: Number;

  static injectables = [LocalStorageUtils, AbTestingUtils, RemoteConfigManager, RouterController];

  constructor(localStorageUtils: LocalStorageUtils, abTestingUtils: AbTestingUtils, remoteConfigManager: RemoteConfigManager, routerController: RouterController) {
    super();

    this.localStorageUtils = localStorageUtils;
    this.abTestingUtils = abTestingUtils;
    this.remoteConfigManager = remoteConfigManager;
    this.routerController = routerController;
    this.pageNum = 0;
  }

  onLoaded() {
    super.onLoaded();

    if (this.state.device.isSmallView && !this.state.appState.appBettingPromotionDisplayModel.isValidVisibility) {
      this.handleModel(this.controller.config.getValue(WEBSITE_MODULE_REMOTE_CONFIG.WEB_TO_APP_CTA));

      this.remoteConfigManager.registerToInitCallback(() => {
        this.handleModel(this.controller.config.getValue(WEBSITE_MODULE_REMOTE_CONFIG.WEB_TO_APP_CTA));
      });

      this.routerController.registerToRouteChange(WebsiteModuleWebToCtaAppHandler.name, () => {
        this.handleRouteChange();
      });
    }

  }

  getLocalStorage(): void {
    const currentDisplayLocalStorageObject: Object = this.localStorageUtils.getJSON(LOCAL_STORAGE_KEYS.webToAppCTADisplay);
    this.model.localStorageModel = new WebToAppCtaLocalStorageModel(currentDisplayLocalStorageObject);

    if (this.model.isDateExpired) {
      this.model.localStorageModel = new WebToAppCtaLocalStorageModel();
    }
    this.model.localStorageModel.incrementSession();

    this.updateLocalStorageModel();
  }

  getABTestingResult() {
    if (this.model.localStorageModel && this.model.localStorageModel.abTestingResult === undefined) {
      const displayPercentage: Number = this.model.remoteConfigModel.displayPercentage;
      const result: Boolean = this.abTestingUtils.getABTestingOption(displayPercentage, 1 - displayPercentage) === 0;
      this.model.localStorageModel.abTestingResult = result;
      this.updateLocalStorageModel();
    }

    return this.model.localStorageModel?.abTestingResult;
  }

  handleModel(model) {
    let isVisible: Boolean = false;

    if (model) {
      this.model.populate(model);
      this.getLocalStorage();

      isVisible = this.model.calcIsVisible(this.state.appState.locale.userCountryId, this.pageNum);

      this.action({isVisible});
    }
  }

  action({isVisible}) {
    const bpShowedInCurrentSession: Boolean = this.state.appState.appBettingPromotionDisplayModel.isValidVisibility;
    let abTestingResult: Boolean = this.getABTestingResult();

    if (!bpShowedInCurrentSession && abTestingResult) {
      this.model.handleVisible(isVisible);
    }

    this.updateLocalStorageModel();
  }

  handleRouteChange() {
    this.pageNum++;

    if (this.pageNum > 1) {
      const isVisible = this.model.calcIsVisible(this.state.appState.locale.userCountryId, this.pageNum);

      this.action({isVisible});
    }
  }

  updateLocalStorageModel() {
    this.localStorageUtils.setJSON(LOCAL_STORAGE_KEYS.webToAppCTADisplay, this.model.localStorageModel);
  }

  get model(): WebToAppCTAModel {
    return this.state.webToAppCTAModel;
  }
}
